import { Directory } from "../../../domain/drawing";
import { FormatSet } from "../../../domain/format";
import { FormatSetDirectoryFilterParameter, FormatSetFilterParameter } from ".";

export class FormatSetTreeFilterParameter {
  constructor(
    private _initializer: (p: FormatSetTreeFilterParameter) => void = null,
    public set: FormatSetFilterParameter = new FormatSetFilterParameter(),
    public directory: FormatSetDirectoryFilterParameter = new FormatSetDirectoryFilterParameter(),
  ) {
  }

  filter(source: FormatSet | Directory<string, FormatSet>): boolean {
    if (source instanceof FormatSet) {
      return this.set.filter(source);
    } else {
      return this.directory.filter(source);
    }
  }

  clear(): void {
    this.set = new FormatSetFilterParameter();
    this.directory = new FormatSetDirectoryFilterParameter();
    this.initialize();
  }

  private initialize(): void {
    if (this._initializer) {
      this._initializer(this);
    }
  }

  clone(): FormatSetTreeFilterParameter {
    return new FormatSetTreeFilterParameter(
      this._initializer,
      this.set.clone(),
      this.directory.clone(),
    );
  }
}
